




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Plans from '../constants/Plans'

@Component

export default class ComponentPlano extends Vue {
  @Prop(Boolean) isUpdatePlan
  @Prop(Boolean) hasDescontoMesesInsencao
  @Prop(Object) plan

  features: Array<any> = []
  plans: Array<any> = Plans
  planStaticInfo: Object = {}

  mounted() {
    this.getFeatures()
  }

  getFeatures() {
    this.plans.map(plan => {
      if (plan.slug == this.plan.chave) this.planStaticInfo = plan
    })
  }
}
